import { ReactNode } from 'react';

import { CanEditFormFields } from '@occc-app/App/CanEditFormFieldsContext';
import { Box, LoadingOverlay } from '@occc-app/design-system';

type FormContainerProps = {
  isReadOnly?: boolean;
  isBusy?: boolean;
  children: ReactNode;
};

export const FormContainer = (props: FormContainerProps) => {
  const { isReadOnly, isBusy, children } = props;

  return (
    <Box position='relative'>
      <CanEditFormFields isEditable={!isReadOnly}>{children}</CanEditFormFields>
      {isBusy ? <LoadingOverlay /> : null}
    </Box>
  );
};
